import userApi from '@/api/user';
import { MiddlewareContext } from '@/interfaces/middleware';
import { UserProps } from '@/interfaces/models/user';
import User from '@/models/user';

export default async (context: MiddlewareContext) => {
  if (context.store.state.user.user === null) {
    return authUser(context);
  }
};

async function authUser(context: MiddlewareContext) {
  if (!window.localStorage.getItem('accessToken')) {
    return redirectToSignIn(context);
  }

  try {
    const user: UserProps = await userApi.tryToAuthUserByCookie();

    context.store.commit('user/setUser', new User(user));
  } catch (error) {
    window.localStorage.removeItem('accessToken');

    return redirectToSignIn(context);
  }
}

function redirectToSignIn({ store, to }: MiddlewareContext) {
  store.commit('user/setAuthBack', to.path);

  return {
    name: 'signIn',
    replace: true
  };
}
